export function buildSharedRoomUrl(
  baseUrl: string,
  token: string,
  contentId?: string | null
): string {
  const normalizedBaseUrl = baseUrl.replace(/\/+$/, '');
  const sharedRoomUrl = `${normalizedBaseUrl}/shared/${encodeURIComponent(token)}`;

  if (!contentId) return sharedRoomUrl;

  const searchParams = new URLSearchParams({ contentId });
  return `${sharedRoomUrl}?${searchParams.toString()}`;
}
